import type { EdsNormalizedValidationOverridesResult } from '@/features/eds/types/normalizedValidationResult';
import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class EdsValidationOverrideFieldDefinitionsEvent extends EventV2<EdsNormalizedValidationOverridesResult> {}
